import React, { useState, useContext } from 'react';
import { Row, Col } from 'react-bootstrap';
import AnimationContainer from '../../components/animation-container';
import BaffleText from '../../components/baffle-text';
import ThemeContext from '../../context';
import PhotoGallery from './gallery';

const Portfolio = ({ id }) => {
  const [show, setShow] = useState(false);
  const context = useContext(ThemeContext);

  const showFunc = () => {
    setShow(true);
  };

  return (
    <section
      id={id}
      className='portfolio'
      style={{ height: context.height }}
      tabIndex='0'
    >
      <Row>
        <Col md={2} className='side'>
          <h2>
            <BaffleText
              text='Portfolio'
              revealDuration={500}
              revealDelay={500}
              parentMethod={showFunc}
              callMethodTime={1100}
            />
          </h2>
        </Col>
        <Col md={10} className='recent-works'>
          <div className='line-text'>
            <h4>See our work</h4>
          </div>
          <AnimationContainer delay={100} animation='fadeIn slow'>
            <PhotoGallery />
          </AnimationContainer>
        </Col>
      </Row>
    </section>
  );
};

export default Portfolio;
